/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.16.0
 * @since 1.15.0
 */

import { EOnboardingComponentsId } from '../../../onboarding/types/onboardingTypes';
import { IOnboardingTranslation } from '../../types';
import { IOnboardingModalTranslation } from '../../types/modules/onboarding';

export const initialOnboardingModalTranslation: IOnboardingModalTranslation = {
    actions: {
        showLater: '',
        skip: '',
        start: '',
    },
    link: {
        url: '',
        label: '',
    },
    text: '',
    title: '',
};

export const initialOnboardingTranslation: IOnboardingTranslation = {
    // @ts-ignore
    elements: Object.values(EOnboardingComponentsId).reduce((obj, id) => ({
        ...obj, [id]: {
            link: {
                url: '',
            },
            text: '',
        },
    }), {}),
    modal: {
        default: initialOnboardingModalTranslation,
        final: initialOnboardingModalTranslation,
        welcome: initialOnboardingModalTranslation,
    },
    tooltip: {
        page: {
            next: '',
        },
        link: {
            default: {
                label: '',
                url: '',
            },
        },
    },
};
